import Index from "./pages/homepage/Index";

export default function App() {
  return <Index/>
}


